import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@fontsource/bodoni-moda/latin-ext-400.css'
import '@fontsource/bodoni-moda/latin-ext-500.css'
import '@fontsource/inter/latin-ext-400.css'
import '@fontsource/inter/latin-ext-500.css'
import '@fontsource/inter/latin-ext-600.css'
import App from './App'
import { ExternalMediaProvider } from './components/ExternalMediaProvider'
import './styles.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ExternalMediaProvider>
        <App />
      </ExternalMediaProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
